import { createContext, useContext } from 'react';

export type KeycloakDisabledReason = 'disabled' | 'missing-config';

export interface KeycloakStatus {
  /**
   * Whether the Keycloak integration is enabled by configuration.
   */
  isEnabled: boolean;
  /**
   * Whether the minimum configuration (authority + clientId) is present.
   */
  isConfigured: boolean;
  /**
   * Provides additional context when integration is disabled.
   */
  reason?: KeycloakDisabledReason;
}

const defaultStatus: KeycloakStatus = {
  isEnabled: true,
  isConfigured: true,
};

const KeycloakStatusContext = createContext<KeycloakStatus>(defaultStatus);

export const KeycloakStatusProvider = KeycloakStatusContext.Provider;

export const useKeycloakStatus = (): KeycloakStatus =>
  useContext(KeycloakStatusContext);
